import React from 'react'
import bg from '../../images/background/5.jpg'

const VenueSection = (props) => {

    return (
        <section className="location-one"  style={{backgroundImage: `url(${bg})`}}>
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Venue</div>
                    <h2 className="sec-title_heading">Direction For The Event</h2>
                </div>
                <div className="row clearfix">
                    <div className="location-one_map-column col-lg-8 col-md-12 col-sm-12">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7259133.6452612365!2d79.42868950230579!3d27.328868634356642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5940e1836c25%3A0xa61ce01f0264fb7b!2sSHOTS%20-%20Cafe%20%26%20Bar%20%7C%20Guwahati!5e0!3m2!1sen!2sin!4v1762674834468!5m2!1sen!2sin"
                            allowFullScreen
                            loading="lazy"
                            title="Venue map"
                        ></iframe>
                    </div>
                    <div className="location-one_info-column col-lg-4 col-md-12 col-sm-12">
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-map"></div>
                                    <strong>ADDRESS</strong>
                                    SHOTS Cafe and Bar, Guwahati
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-clock"></div>
                                    <strong>timing</strong>
                                    June 22, 2025
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-email-1"></div>
                                    <strong>MAIL TO US</strong>
                                    hello@thelushminds.in
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default VenueSection;